"use client";
import React from "react";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";

interface PayWaitingDialogProps extends SDialogProps {
}

export const PayIOSTipsDialogFC: React.FC<PayWaitingDialogProps> = (props) => {
    const { fcKey,onClose } = props;
    const {closeDialog} = useDialogMethods(fcKey);
    const onClickGo = () => {
        onClose?.();
        closeDialog();
    }
    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Center"
            title={
                <p style={{ marginBottom: ".4rem", fontSize: ".6rem", fontWeight: "bold" }}>
                    Payment is being processed..
                </p>
            }
            buttons={[
                {
                    label: "GO",
                    onClick: onClickGo,
                    style: "greenBtn",
                },
            ]}
        >
            <p>
                Click to go to the payment page.
            </p>
        </SDialogFC>
    );
};